import {
  Box,
  Button,
  FileUpload,
  useFileUploadContext,
} from "@chakra-ui/react";
import { FileItem } from "./FileItem";
import { useTranslations } from "next-intl";

export const FileListV2 = () => {
  const t = useTranslations("space.talent_pool.file_upload.errors");
  const fileUpload = useFileUploadContext();
  const files = fileUpload.acceptedFiles;
  const rejectedFiles = fileUpload.rejectedFiles;

  if (files.length === 0 && rejectedFiles.length === 0) return null;

  const getErrorMessage = (errorKey: string) => {
    switch (errorKey) {
      case "FILE_TOO_LARGE":
        return t("file_too_large");
      case "TOO_MANY_FILES":
        return t("too_many_files");
      case "FILE_ALREADY_UPLOADED":
        return t("file_already_uploaded");
      default:
        return t("invalid_file");
    }
  };

  return (
    <>
      <FileUpload.ItemGroup
        gap={0}
        maxH="25rem"
        overflowY="auto"
        scrollbarGutter="stable"
        id="file-list-v2"
      >
        {files.map((file) => (
          <FileItem key={file.name} file={file} />
        ))}
        {rejectedFiles.map((rejectedFile) => {
          const errorKey = rejectedFile.errors[0];
          const errorMessage = getErrorMessage(errorKey);

          return (
            <FileItem
              key={rejectedFile.file.name}
              file={rejectedFile.file}
              errorMessage={errorMessage}
              isRejected={true}
            />
          );
        })}
      </FileUpload.ItemGroup>

      <Box alignSelf="center" px={3}>
        <ClearAllButton />
      </Box>
    </>
  );
};

const ClearAllButton = () => {
  const t = useTranslations("space.talent_pool.file_upload");
  const fileUpload = useFileUploadContext();
  const files = fileUpload.acceptedFiles;

  if (files.length === 0) return null;

  const handleClear = () => {
    fileUpload.clearFiles();
    fileUpload.clearRejectedFiles();
  };

  return (
    <Button
      colorPalette="neutral"
      visual="none-style"
      size="xs"
      onClick={handleClear}
      mt={2}
      _hover={{
        bg: "neutral.900",
        color: "neutral.50",
      }}
      transition="all 0.2s ease-in-out"
    >
      {t("clear_all_files")}
    </Button>
  );
};
